import { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import NonIdealNew from "../../common/NonIdealNew";
import CashBookList from "../../container/CashBook/CashBookList";
import { LanguageContext } from "../../../context/LanguageContext";
import { analytics, triggerLogEvent } from "../../../config/firebase";
import { Grid } from "@mui/material";
import { InnerWrapper, MainContainer, TitleAndActionBox } from "../../common";
import { UBButton } from "../../../Libraries";
import withObservables from "@nozbe/with-observables";
import { observeCashTxnCountByBusiness } from "../../../database/helpers/cash_txn";
import { useAuthContext } from "../../../context/AuthContext";

const CashBook = ({ cashTxnCount }) => {
  const [I18n] = useContext(LanguageContext);
  const { business, user } = useAuthContext();
  const navigate = useNavigate();

  const isNonIdeal = cashTxnCount <= 0;

  useEffect(() => {
    triggerLogEvent(analytics, "cash_book_visited");
  }, []);

  return (
    <MainContainer fluid className="quickSalePage">
      <Grid container>
        <Grid item md={12}>
          <TitleAndActionBox data={{ title: I18n.cash_book }}>
            <UBButton
              id="add_money_in_btn"
              className="ubPrimaryButton fontSize12 fontWeight400 textUppercase marginLeft12"
              title={I18n.in}
              onClick={() => {
                triggerLogEvent(analytics, "cash_book_add_money_in");
                navigate("/Sales/CashBook/CashIn");
              }}
            />
            <UBButton
              id="add_money_out_btn"
              className="ubSecondaryButton fontSize12 fontWeight400 textUppercase marginLeft12"
              title={I18n.out}
              onClick={() => {
                triggerLogEvent(analytics, "cash_book_add_money_out");
                navigate("/Sales/CashBook/CashOut");
              }}
            />
          </TitleAndActionBox>
          <InnerWrapper className="innerWrapper newInnerWrapper">
            {isNonIdeal ? (
              <NonIdealNew
                title={I18n.track_every_rupee}
                subtitle={I18n.record_daily_cash_in_and_cash_out}
                button1Title="in"
                onButton1Click={() => {
                  triggerLogEvent(analytics, "cash_book_non_ideal_add_money_in");
                  navigate("/Sales/CashBook/CashIn");
                }}
                listButton2Title="out"
                isTransparentListButton2
                onListButton2Click={() => {
                  triggerLogEvent(analytics, "cash_book_non_ideal_add_money_out")
                  navigate("/Sales/CashBook/CashOut");
                }}
                loading={false}
                disabledOne={false}
                buttonOneId="add_money_in_non_ideal"
                listButtonTwoId="add_money_out_non_ideal"
              />
            ) : (
              <CashBookList business={business} user={user} />
            )}
          </InnerWrapper>
        </Grid>
      </Grid>
    </MainContainer>
  );
};

const enhance = withObservables([], () => ({
  cashTxnCount: observeCashTxnCountByBusiness(localStorage.getItem("business_id")),
}));

export default enhance(CashBook);
